import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ProfileService } from "src/app/services/profile.service";
import { SelectdropdownService } from "src/app/services/selectdropdown.service";
import { AddrequestService } from "src/app/services/addrequest.service";
import { PortalUserDto } from 'src/app/models/portalUserDto';
import { ProtalAttachmentSetting } from 'src/app/models/ProtalAttachmentSetting';
import { PortalRequestAttachmentCreate } from 'src/app/models/PortalRequestAttachmentCreate';
import { portalRequestCreate } from 'src/app/models/portalRequestCreate';
import { DatePipe } from '@angular/common';
import { ActivatedRoute,Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { faDownload, faTrash, faPlusCircle, faEdit } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ScPortalRequestIncome } from 'src/app/models/ScPortalRequestIncome';
import { ScPortalRequestDuties } from 'src/app/models/ScPortalRequestDuties';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { IncomemodalComponent } from 'src/app/components/incomemodal/incomemodal.component';
import { DutymodalComponent } from 'src/app/components/dutymodal/dutymodal.component';
import { SelectdropdownResultResults } from 'src/app/models/selectdropdown';
import { MainpageService } from 'src/app/services/mainpage.service';
import { RequestmodalValidationComponent } from '../requestmodal-validation/requestmodal-validation.component';


@Component({
  selector: 'app-addrequest',
  templateUrl: './addrequest.component.html',
  styleUrls: ['./addrequest.component.css'],
  providers: [ DatePipe ]
})
export class AddrequestComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  result:any;
  lang:string;

  constructor(
    private datePipe: DatePipe,
    private ProfileService:ProfileService,
    private dropdownsService:SelectdropdownService,
    private AddrequestService:AddrequestService,
    private route: ActivatedRoute,
    private matDialog:MatDialog,
    private router: Router,
    private toastr: ToastrService,
    public translate: TranslateService,
    private mainPageService: MainpageService,
    private requestModalvalid:MatDialog,
  ) {}

  // Slider
  customOptions: OwlOptions = {
    rtl:true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    responsive: {
      0: {
        items: 1
      },
      555: {
        items: 2
      },
      840: {
        items: 3
      },
      // 930: {
      //   items: 3
      // }
    },
    nav: false
   }

  downloadIcon=faDownload;
  items=[
    {id:1,logo:'omkween.png',status:false,available:true},
    {id:2,logo:'saud-charity.png',status:false,available:true},
    {id:6,logo:'invalid-name.png',status:false,available:true}
  ];

  // Icons
  deleteIcon=faTrash;
  addIcon=faPlusCircle;
  editIcon=faEdit;
  // ======
 
  stepNumber=1;
  showStepper=true;
  editRequest=false;
  viewRequest=false;
  loadingOverlay = true;
  attachmentError = false;
  userData = new PortalUserDto();
  citiesList:any=[];
  genderList:any=[];
  maritalstatusList:any=[];
  nationalityList:any=[];
  scPortalRequestStatuesList:any=[];
  aidRequestTypeList:any=[];
  aidRequestTypeListGroup:any=[];
  dataScDutiesList:any=[];
  addRequest = new portalRequestCreate();

  attachmentArray:ProtalAttachmentSetting[]=[];
  errorMessage: string = '';
  toastrMsgs:any;
  dataIncomeList:any=[];
  IncomeEditObj:ScPortalRequestIncome;
  DutiesEditObj:ScPortalRequestDuties;
  IncomeEditObjIndex=null;
  DutiesEditObjIndex=null;
  branchList:any=[];
  // Errors
  aidRequestTypeError=false;
  descriptionError=false;
  branchLkpError=false;
  
  ngOnInit() {
    this.lang = localStorage.getItem('lang');
    this.RequestPortalvalidation(this.lang);
    this.getToastrMsgs(); 
    this.addRequest.requestAttachments = [];
    this.addRequest.requestIncomes = [];
    this.addRequest.requestDuties = [];
    this.AddrequestService.GetAvailableTenants()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{      
      let Data = data.map(x=>x.tenantId);      
      this.items.forEach(item => {
        if(!Data.includes(item.id)){
          item.available=false;
        }
      });      
    })

    this.ProfileService.GetProfileData()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      console.log(data);
     
      this.userData =  data.result;
      this.userData.birthDate = this.fromStringToDate(data.result.birthDate);
      this.userData.idExpirationDate = this.fromStringToDate(data.result.idExpirationDate);
      this.loadingOverlay = false;
    });
    this.initIncomeEditObj();
    this.initDutiesEditObj(); 
    this.route.paramMap.subscribe(params => {
      if(params.get('view')){
        this.viewRequest = true;
      }
      if(params.get('id') && params.get('tenantId')){
        this.showStepper=false;
        this.editRequest=true;
        this.AddrequestService.GetRequest(params.get('id'),params.get('tenantId'))
        .pipe(takeUntil(this.destroy$))
        .subscribe(data=>{
          debugger
          console.log(data);
        
          this.addRequest.portalRequestNumber = data.portalRequestNumber;
          this.addRequest.portalRequestDate = this.fromStringToDate(data.portalRequestDate);
        //  this.addRequest.aidRequestTypeTr=data.aidRequestTypeTr;
        
    
           this.addRequest.aidRequestTypeLkpId = data.aidRequestTypeLkpId;
       
        
           this.addRequest.AidRequestTypeTrName=data.aidRequestTypeTr.AidRequestTypeTrName;

          this.addRequest.statusLkpId = data.statusLkpId;
          this.addRequest.description = data.description;
          this.addRequest.tenantId = data.tenantId;
          this.addRequest.id = data.id;
          this.addRequest.branchLkpId=data.branchLkpId;
          this.dropdownsService.GetAidRequestTypeLkpForGroup(this.addRequest.tenantId,this.addRequest.aidRequestTypeLkpId)
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.aidRequestTypeListGroup = data;
    });


    this.addRequest.aidRequestTrTypeId = data.aidRequestTypeTr.id;
          data.attachments.forEach(element => {
            this.addRequest.requestAttachments.push(element)
          });
          data.requestIncomes.forEach(element => {
            this.addRequest.requestIncomes.push(element)
          });
         
         data.requestDuties.forEach(element => {
            this.addRequest.requestDuties.push(element)
          }); 

          this.AddrequestService.GetAttachmentData(this.addRequest.aidRequestTrTypeId)
          .pipe(takeUntil(this.destroy$))
          .subscribe(data=>{
            this.attachmentArray = data;
            this.addRequest.requestAttachments.forEach(att => {
              this.attachmentArray.forEach(x => {
                if(x.id == att.protalAttachmentSettingId){
                  x.filePath = att.filePath;
                  x.fileExt = att.filePath.substring(att.filePath.lastIndexOf(".") + 1);
                }
              });
            });
          })
          this.next();
        })
      }
    });

    // Cities Select Drop Down
    this.dropdownsService.GetCitiesList()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.citiesList = data;
    })

    // Gender Select Drop Down
    this.dropdownsService.GetGenderList()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.genderList = data;
    })

    // MaritalStatus Select Drop Down
    this.dropdownsService.GetMaritalStatusList()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.maritalstatusList = data;
    })

    // Nationality Select Drop Down
    this.dropdownsService.GetNationalityList()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.nationalityList = data;
    })

    this.dropdownsService.GetAidRequestTypeLkp(this.addRequest.tenantId)
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      debugger
      console.log(data);
      this.aidRequestTypeList = data;
    })

// debugger;
//     this.dropdownsService.GetAidRequestTypeLkpForGroup(this.addRequest.tenantId,this.addRequest.aidRequestTypeLkpId)
//     .pipe(takeUntil(this.destroy$))
//     .subscribe(data=>{
//       this.aidRequestTypeListGroup = data;
//     })
    
    
    this.dropdownsService.GetRequestIncome()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.dataIncomeList = data;
    })
    
      this.dropdownsService.GetDataScDuties()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data=>{   
        this.dataScDutiesList = data;
      })
      
  
      this.dropdownsService.Getbranch()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data=>{
        this.branchList = data;
      })


    // RequestStatues Select Drop Down
    this.dropdownsService.GetScPortalRequestStatuesList()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.scPortalRequestStatuesList = data;      
      this.addRequest.statusLkpId = 149;
    })

    this.addRequest.portalRequestDate = new Date();

  }

  ngOnDestroy() {
    this.destroy$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.destroy$.unsubscribe();
  }

  fromStringToDate(str):any{
    let parts = str.split("/");
    return new Date(parts[2], parts[1] - 1, parts[0])
  }

  chooseItem(index,available){
    if(available){
      this.items.map(x=>x.status=false);
      this.items[index].status=true;
      this.addRequest.tenantId = this.items[index].id;
    }
  }

  getToastrMsgs(){
    this.translate.get('ToastrSuccess')
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{      
      this.toastrMsgs = data;
    })
  }
  getTextFromSelect(id:number,list:SelectdropdownResultResults[]){
    let obj =  list.find(x=>x.id == id);
    if (obj) {
      return obj.text
    }
  }
  next(){
    if(this.stepNumber == 1 && this.addRequest.tenantId){
      this.stepNumber++;
      this.dropdownsService.GetAidRequestTypeLkp(this.addRequest.tenantId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(data=>{
        this.aidRequestTypeList = data;
      })
    }else{
      return false;
    }
  }

  initIncomeEditObj(){
    this.IncomeEditObj= new ScPortalRequestIncome();
    this.IncomeEditObjIndex = null;
    this.IncomeEditObj.scIncomeId=null;
  }

  initDutiesEditObj(){
    this.DutiesEditObj= new ScPortalRequestDuties();
    this.DutiesEditObjIndex = null;
  this.DutiesEditObj.scDutiesId=null;
    
  }

  addIncome(){
    let matDialog = new MatDialogConfig();
    matDialog.disableClose = true;
    matDialog.data = {IncomeEditObjIndex: this.IncomeEditObjIndex,
       IncomeEditObj: this.IncomeEditObj,
       dataIncomeList:this.dataIncomeList}
    this.matDialog.open(IncomemodalComponent,matDialog)
    .afterClosed().subscribe(res=>{
      if(res == null || res == undefined){
        this.initIncomeEditObj();
        return false
      }else{
        console.log(res);
        let newIncome = new ScPortalRequestIncome();
        newIncome.rowStatus = 'New';
        newIncome.scIncomeId = res.scIncomeId;
        newIncome.incomeSourceName= this.getTextFromSelect(this.IncomeEditObj.scIncomeId,this.dataIncomeList);
        newIncome.monthlyIncomeAmount = res.monthlyIncomeAmount;
        this.addRequest.requestIncomes.push(newIncome);
        this.initIncomeEditObj();
      }
    });
  }


  addDuty(){
   
    let matDialog = new MatDialogConfig();
    matDialog.disableClose = true;
    matDialog.data = {DutiesEditObjIndex: this.DutiesEditObjIndex,
       DutiesEditObj: this.DutiesEditObj,
        dataScDutiesList:this.dataScDutiesList}
   console.log(matDialog.data);
    this.matDialog.open(DutymodalComponent,matDialog)
    .afterClosed().subscribe(res=>{
      if(res == null || res == undefined){
        this.initDutiesEditObj();
        return false
      }else{
        
        console.log(res);
        let newDuty = new ScPortalRequestDuties();
        newDuty.rowStatus = 'New';
        newDuty.scDutiesId = res.scDutiesId;      
       // newDuty.scDutiesNdutyTypeame = res.dutyType; 
        newDuty.dutyType = this.getTextFromSelect(this.DutiesEditObj.scDutiesId,this.dataScDutiesList);

        newDuty.dutyDescription = res.dutyDescription;
        newDuty.monthlyAmount = res.monthlyAmount;
        newDuty.totalAmount = res.totalAmount;
        this.addRequest.requestDuties.push(newDuty);
        this.initDutiesEditObj();
      }
    });
  }

  editIncome(i){
    this.IncomeEditObj.id = this.addRequest.requestIncomes[i].id;
  
    this.IncomeEditObj.scIncomeId = this.addRequest.requestIncomes[i].scIncomeId;
    this.IncomeEditObj.incomeSourceName= this.addRequest.requestIncomes[i].incomeSourceName;
    this.IncomeEditObj.monthlyIncomeAmount = this.addRequest.requestIncomes[i].monthlyIncomeAmount;
    this.IncomeEditObjIndex = i;
    let matDialog = new MatDialogConfig();
    matDialog.disableClose = true;
    matDialog.data = {IncomeEditObjIndex: this.IncomeEditObjIndex, IncomeEditObj: this.IncomeEditObj,dataIncomeList:this.dataIncomeList}
    this.matDialog.open(IncomemodalComponent,matDialog)
    .afterClosed().subscribe(res=>{
      if(res == null || res == undefined){
        this.initIncomeEditObj();
        return false
      }else{
        console.log(res);
        let newIncome = new ScPortalRequestIncome();
        newIncome.id = this.IncomeEditObj.id;
        newIncome.scIncomeId = this.IncomeEditObj.scIncomeId;
      //  newIncome.incomeSourceName = this.IncomeEditObj.incomeSourceName;
      newIncome.incomeSourceName= this.getTextFromSelect(this.IncomeEditObj.scIncomeId,this.dataIncomeList);
        newIncome.monthlyIncomeAmount = this.IncomeEditObj.monthlyIncomeAmount;
        if(newIncome.id){
          newIncome.rowStatus = 'Updated';
          let income = this.addRequest.requestIncomes[this.IncomeEditObjIndex];
          income.scIncomeId = newIncome.scIncomeId;
          income.incomeSourceName= this.getTextFromSelect(this.IncomeEditObj.scIncomeId,this.dataIncomeList);

          income.monthlyIncomeAmount = newIncome.monthlyIncomeAmount;
          income.rowStatus = newIncome.rowStatus;
        }else{
          let income = this.addRequest.requestIncomes[this.IncomeEditObjIndex];
          income.scIncomeId = newIncome.scIncomeId;
          income.incomeSourceName= this.getTextFromSelect(this.IncomeEditObj.scIncomeId,this.dataIncomeList);
          income.monthlyIncomeAmount = newIncome.monthlyIncomeAmount;
        }
        this.initIncomeEditObj();
      }
    });
  }

  editDuty(i){
    this.DutiesEditObj.id = this.addRequest.requestDuties[i].id;
    this.DutiesEditObj.scDutiesId = this.addRequest.requestDuties[i].scDutiesId;
    this.DutiesEditObj.dutyType = this.addRequest.requestDuties[i].dutyType;
    this.DutiesEditObj.dutyDescription = this.addRequest.requestDuties[i].dutyDescription;
    this.DutiesEditObj.monthlyAmount = this.addRequest.requestDuties[i].monthlyAmount;
    this.DutiesEditObj.totalAmount = this.addRequest.requestDuties[i].totalAmount;
    this.DutiesEditObjIndex = i;
    let matDialog = new MatDialogConfig();
    matDialog.disableClose = true;
    matDialog.data = {DutiesEditObjIndex: this.DutiesEditObjIndex, DutiesEditObj: this.DutiesEditObj,dataScDutiesList:this.dataScDutiesList}
    this.matDialog.open(DutymodalComponent,matDialog)
    .afterClosed().subscribe(res=>{
      if(res == null || res == undefined){
        this.initDutiesEditObj();
        return false
      }else{
        console.log(res);
        let newDuty = new ScPortalRequestDuties();
        newDuty.id = this.DutiesEditObj.id;
        newDuty.scDutiesId = this.DutiesEditObj.scDutiesId;
        newDuty.dutyType = this.getTextFromSelect(this.DutiesEditObj.scDutiesId,this.dataScDutiesList);
        newDuty.dutyDescription = this.DutiesEditObj.dutyDescription;
        newDuty.monthlyAmount = this.DutiesEditObj.monthlyAmount;
        newDuty.totalAmount = this.DutiesEditObj.totalAmount;
        if(newDuty.id){
          newDuty.rowStatus = 'Updated';
          let duty = this.addRequest.requestDuties[this.DutiesEditObjIndex];
          duty.scDutiesId = newDuty.scDutiesId;
          duty.dutyType = this.getTextFromSelect(this.DutiesEditObj.scDutiesId,this.dataScDutiesList);
          duty.dutyDescription = newDuty.dutyDescription;
          duty.monthlyAmount = newDuty.monthlyAmount;
          duty.totalAmount = newDuty.totalAmount;
          duty.rowStatus = newDuty.rowStatus;
        }else{
          let duty = this.addRequest.requestDuties[this.DutiesEditObjIndex];
          duty.scDutiesId = newDuty.scDutiesId;
          duty.dutyType = this.getTextFromSelect(this.DutiesEditObj.scDutiesId,this.dataScDutiesList);
          duty.dutyDescription = newDuty.dutyDescription;
          duty.monthlyAmount = newDuty.monthlyAmount;
          duty.totalAmount = newDuty.totalAmount;
        }
        this.initDutiesEditObj();
      }
    });
  }

  deleteIncome(i){
    let income = this.addRequest.requestIncomes[i];
    if (income.id) {
      income.rowStatus = 'Deleted';
    }else{
      this.addRequest.requestIncomes.splice(i, 1);
    }
  }

  deleteDuty(i){
    let duty = this.addRequest.requestDuties[i];
    if (duty.id) {
      duty.rowStatus = 'Deleted';
    }else{
      this.addRequest.requestDuties.splice(i, 1);
    }
  }
  GetAidRequestTypeLkpForGroup(event){  
    this.dropdownsService.GetAidRequestTypeLkpForGroup(this.addRequest.tenantId,this.addRequest.aidRequestTypeLkpId)
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.aidRequestTypeListGroup = data;
    })
  }
  onRequestTypeChange(){
    debugger
    console.log('changed');
    
    while(this.attachmentArray.length > 0){
      this.attachmentArray.pop();
    }
    while(this.addRequest.requestAttachments.length > 0){
      this.addRequest.requestAttachments.pop();
    }
    this.aidRequestTypeError = false;
    this.AddrequestService.GetAttachmentData(this.addRequest.aidRequestTrTypeId)
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      console.log(data);
      this.attachmentArray = data;
    })
  }

  formatBase64(item:string){
    return item.split(',')[1]
  }

  getPic(fileExt:string){
    if(fileExt){
      if(fileExt.toLowerCase().includes("png") || fileExt.toLowerCase().includes("jpg") || fileExt.toLowerCase().includes("jpeg")){
        return 1
      }else{
        return 2
      }
    }
  }

  onFileChange(event,id){
    if(this.editRequest){
      if (event.target.files.length > 0) {
        const file = event.target.files[0];
        this.AddrequestService.UploadAttach(file)
        .subscribe(data =>{
          console.log(data);
          let attatch = this.attachmentArray.find(x=>x.id == id);
          attatch.fileName = file.name;
          attatch.filePath = data.result;
          let lastIndex = attatch.fileName.lastIndexOf(".") + 1;
          attatch.fileExt = attatch.fileName.substring(lastIndex);
          let item = this.addRequest.requestAttachments.find(x=>x.protalAttachmentSettingId == attatch.id);
          if(item){
            item.filePath = attatch.filePath;
            item.fileExt =  attatch.fileExt;
            item.rowStatus = 'Updated';
          }else{
            let newAttachmentInAddRequest = new PortalRequestAttachmentCreate(); 
            newAttachmentInAddRequest.filePath = attatch.filePath;
            newAttachmentInAddRequest.fileExt =  attatch.fileExt;
            newAttachmentInAddRequest.tenantId = this.addRequest.tenantId;
            newAttachmentInAddRequest.protalAttachmentSettingId = attatch.id;
            newAttachmentInAddRequest.portalRequestId = 0;
            newAttachmentInAddRequest.rowStatus = 'New';
            this.addRequest.requestAttachments.push(newAttachmentInAddRequest);
          }

        })
      }
    }else{
      if (event.target.files.length > 0) {
        let file = event.target.files[0];
        this.AddrequestService.UploadAttach(file)
        .subscribe(data =>{
          console.log(data);
          let attatch = this.attachmentArray.find(x=>x.id == id);
          attatch.fileName = file.name;
          attatch.filePath = data.result;
          let lastIndex = attatch.fileName.lastIndexOf(".") + 1;
          attatch.fileExt = attatch.fileName.substring(lastIndex);
          let newAttachmentInAddRequest = new PortalRequestAttachmentCreate(); 
            newAttachmentInAddRequest.filePath = attatch.filePath;
            newAttachmentInAddRequest.fileExt =  attatch.fileExt;
            newAttachmentInAddRequest.tenantId = this.addRequest.tenantId;
            newAttachmentInAddRequest.protalAttachmentSettingId = attatch.id;
            newAttachmentInAddRequest.portalRequestId = 0;
            newAttachmentInAddRequest.rowStatus = 'New';
            this.addRequest.requestAttachments.forEach((element,i) => {
              if(element.protalAttachmentSettingId == newAttachmentInAddRequest.protalAttachmentSettingId){
                this.addRequest.requestAttachments.splice(i,1);
              }
            });
            this.addRequest.requestAttachments.push(newAttachmentInAddRequest);
        })
        
      }
    }
  }

  validate(){
    if(!this.addRequest.aidRequestTypeLkpId){this.aidRequestTypeError=true;}else{this.aidRequestTypeError=false;}
    if(!this.addRequest.branchLkpId){this.branchLkpError=true;}else{this.branchLkpError=false;}
    if(!this.addRequest.description){this.descriptionError=true;}else{this.descriptionError=false;}
    if (this.aidRequestTypeError==true || this.attachmentError==true || this.descriptionError==true || this.branchLkpError==true) {
      return false;
    }else{
      return true
    }
  }

  validateAttachment(){
    let attErr = this.attachmentArray.find(x=>x.isRequired == true && !x.filePath);
    if(attErr){this.attachmentError=true;}else{this.attachmentError=false;}
  }

  focused(event){
  
    if(event.target.previousSibling.classList.contains('label-over')){
      return false;
    }else{
      event.target.previousSibling.classList.add('label-over');
    }
  }

  blured(event,value){
    
    if(event.target.previousSibling.classList.contains('label-over') && !value){
      event.target.previousSibling.classList.remove('label-over');
    }else{
      return false;
    }
  }

  RequestPortalvalidation(lang: string) {
    this.mainPageService.GetRequestPortalvalidation(lang).subscribe(data => {
      console.log(data.result);
      if (data.result.finalStatues === 'F') {
        this.errorMessage = data.result.reason;
      } else if (data.result.finalStatues === 'S') {
        console.log('Final Status is S');
      }
    });
  }
  
  
  // else if(this.result=="F") {
  //   let matDialogvalid = new MatDialogConfig();
  //         matDialogvalid.disableClose = true;
  //         matDialogvalid.maxWidth = "500px";
  //         this.requestModalvalid.open(RequestmodalValidationComponent, matDialogvalid)
  //           .afterClosed().subscribe(res => {
  //             return false;
  //           });

  //           return false;
  
//   }
//   else if(this.result=="S")
//  {return true;
//   }
public isButtonDisabled: boolean = false;
  sendRequest(){
    this.mainPageService.GetValidationDataOnAddRequest().subscribe(response => {
      if (this.addRequest.branchLkpId==null) {
        this.toastr.error("الرجاء إدخال اسم الفرع");
        return;
      }
      else if(this.addRequest.aidRequestTrTypeId==null){
        this.toastr.error("الرجاء إدخال التصنيف الرئيسي للطلب و التصنيف الفرعي للطلب");
        return;
      }
      else if(this.addRequest.description==null){
        this.toastr.error("الرجاء إدخال شرح الحالة");
        return;
      }
     // this.result=response.result.finalStatues;
     if(response.result.finalStatues=="F") {
      let matDialogvalid = new MatDialogConfig();
            matDialogvalid.disableClose = true;
            matDialogvalid.maxWidth = "500px";
            this.requestModalvalid.open(RequestmodalValidationComponent, matDialogvalid)
              .afterClosed().subscribe(res => {
                return false;
              });
             }
            
else{
    // this.validateAttachment();
    // if(this.validate()){
    //   this.loadingOverlay = true;
    //   this.addRequest.sourceLkpId = 153;
    //   this.addRequest.portalRequestDate = this.addRequest.portalRequestDate.toLocaleString();
    //   console.log(this.addRequest);
    //   this.AddrequestService.SendRequest(this.addRequest)
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe(data=>{
    //     this.toastr.success(this.toastrMsgs.addRequest);
    //     this.loadingOverlay = false;
    //     setTimeout(() => {
    //       this.router.navigate(['board/main'])
    //     }, 500);
    //   },error=>{
    //     this.toastr.error(error.error.error.message);
    //     this.loadingOverlay = false;

    if (!this.isButtonDisabled && this.validate()) {
      this.isButtonDisabled = true;
      this.loadingOverlay = true;
      this.addRequest.sourceLkpId = 153;
      this.addRequest.portalRequestDate = this.addRequest.portalRequestDate.toLocaleString();
      console.log(this.addRequest);
      this.AddrequestService.SendRequest(this.addRequest)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (data) => {
            this.toastr.success(this.toastrMsgs.addRequest);
            this.loadingOverlay = false;
            setTimeout(() => {
              this.router.navigate(['board/main']);
            }, 500);
          },
          (error) => {
            this.toastr.error(error.error.error.message);
            this.loadingOverlay = false;
      })
    }}
  });
  }

  updateRequest(){
    this.validateAttachment();
    if(this.validate()){
      this.loadingOverlay = true;
      this.addRequest.sourceLkpId = 153;
      console.log(this.addRequest);
      this.AddrequestService.EditRequest(this.addRequest)
      .pipe(takeUntil(this.destroy$))
      .subscribe(data=>{
        this.toastr.success(this.toastrMsgs.editRequest);
        this.loadingOverlay = false;
        setTimeout(() => {
          this.router.navigate(['board/main'])
        }, 500);
      },error=>{
        this.toastr.error(error.error.error.message);
        this.loadingOverlay = false;
      })
    }
  }

}
